import { PlusOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { DESC, ITEMS_PER_PAGE } from 'app/shared/util/pagination.constants';
import React, { useEffect, useState } from 'react';
import { getPaginationState } from 'react-jhipster';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Container } from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Dropdown, Input, MenuProps, Space, Switch, Tooltip } from 'antd';
import Title from 'antd/es/typography/Title';
import ModalConfirmComponent from 'app/shared/component/modal/confirm';
import TableComponent from 'app/shared/component/table/table';
import { deleteEntity, getEntities } from '../work-group.reducer';
import { columns } from './config';
import { PlantPeriodType } from 'app/shared/model/enum/plantPeriod.enum';

const { Search } = Input;

export const WorkType = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const pageLocation = useLocation();
  const { filter } = pageLocation.state || {};
  const searchParams = new URLSearchParams(pageLocation.search);

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'lastModifiedDate', DESC), pageLocation.search),
  );

  const planPeriodList = useAppSelector(state => state.workGroup.entities);
  const totalItems = useAppSelector(state => state.workGroup.totalItems);
  const [visibleConfirmDelete, setVisibleConfirmDelete] = useState(false);
  const [idDeletedObjective, setIdDeletedObjective] = useState(null);

  const [searchText, setSearchText] = useState();
  const [filters, setFilter] = useState<any>(filter);

  // config columns, actions add plan period
  const newColumns = [
    ...columns,
    {
      title: 'Hành động',
      key: 'Action',
      fixed: 'right',
      width: 80,
      render: (item: any) => (
        <div className="action">
          <span className="action-edit">
            {true /*(isAdmin || objectivePermissions.Update)*/ && (
              <Tooltip title="Sửa">
                <Link state={{ filter: filters }} to={`/work-type/${item.id}`}>
                  <FontAwesomeIcon icon="pencil-alt" />
                </Link>
              </Tooltip>
            )}
          </span>
          <span className="action-delete">
            <Tooltip title="Xóa">
              <FontAwesomeIcon
                onClick={() => {
                  handleWarningDeleteItem(item.id);
                }}
                icon="trash"
              />
            </Tooltip>
          </span>
        </div>
      ),
    },
  ];

  useEffect(() => {
    initial();
  }, []);

  useEffect(() => {
    getAllEntities();
  }, [paginationState, filters]);

  const initial = () => {
    getAllEntities();
  };

  const getAllEntities = (value?: string) => {
    dispatch(
      getEntities({
        searchText: value ?? searchText,
        page: value ? 0 : paginationState.activePage,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
        filters,
      }),
    );
  };

  const handleChange = (pageNumber: number, size: number, sorter: any) => {
    setPaginationState({
      ...paginationState,
      order: DESC, //sorter.order && OrderByType[sorter.order] === OrderByType.descend ? DESC : ASC,
      sort: sorter.columnKey,
      activePage: pageNumber,
      itemsPerPage: size,
    });
  };

  const handleWarningDeleteItem = (id: number) => {
    setVisibleConfirmDelete(true);
    setIdDeletedObjective(id);
  };

  const handleConfirmDelete = () => {
    if (idDeletedObjective) {
      dispatch(deleteEntity(idDeletedObjective))
        .then(() => {
          getAllEntities();
        })
        .finally(() => {
          setVisibleConfirmDelete(false);
        });
    }
  };

  const handleFreeTextSearchQuery = query => {
    setSearchText(query);
    getAllEntities(query);
  };

  const handleAdd = () => {
    navigate('new');
  };

  return (
    <Container className="view">
      <div className="d-flex gap-5">
        <Title level={3}>Danh sách mảng công việc</Title>
      </div>
      <div className="table">
        <div className="header">
          <Space className="search">
            <Search size="large" allowClear placeholder="Nhập giá trị tìm kiếm" onSearch={handleFreeTextSearchQuery} enterButton />
          </Space>
          <Space>
            <Button
              size="large"
              onClick={() => {
                handleAdd();
              }}
              className="primary"
              icon={<PlusOutlined />}
            >
              Thêm mới
            </Button>
          </Space>
        </div>
        <TableComponent
          data={planPeriodList.map((x, index) => {
            return {
              key: index + 1,
              ...x,
            };
          })}
          scroll={false}
          total={totalItems}
          isFetching={false}
          columns={newColumns}
          handlePageChange={(pageNumber: number, size: number, search: any, sorter: any) => {
            handleChange(pageNumber, size, sorter);
          }}
        />
      </div>
      <ModalConfirmComponent
        visible={visibleConfirmDelete}
        onCancel={() => {
          setVisibleConfirmDelete(false);
        }}
        onConfirm={handleConfirmDelete}
        title={`Bạn có muốn xóa mảng công việc`}
      />
    </Container>
  );
};

export default WorkType;
